import {
  isMarketSingle,
  isMarketSettled,
  isMarketExpired,
} from '@/utils/helpers'
import { mapGetters, mapState } from 'vuex';

export default {
  props: {
    contract: {},
    market: {},
    handleJourneyOpened: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'hasMaintenance']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('trade', ['tradeOptions']),
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    isMarketSettled() {
      return isMarketSettled(this.market);
    },
    classModifiers() {
      const isPurchaseJourneyOpened = this.handleJourneyOpened &&
        (this.tradeOptions.contractId === this.contract.contractId);

      return {
        'market-disabled-outcome-v2': true,
        'market-disabled-outcome-v2--settled': this.isMarketSettled,
        'market-disabled-outcome-v2--journey-opened': isPurchaseJourneyOpened,
        'market-disabled-outcome-v2--journey-opened--yes': isPurchaseJourneyOpened && this.tradeOptions.operationValue === 'yes',
        'market-disabled-outcome-v2--journey-opened--no': isPurchaseJourneyOpened && this.tradeOptions.operationValue === 'no',
      };
    },
    iconClassModifiers() {
      return {
        'market-disabled-outcome-v2__icon': true,
        'market-disabled-outcome-v2__icon--yes': this.isMarketSettled && this.isWinnerYes,
        'market-disabled-outcome-v2__icon--no': this.isMarketSettled && this.isWinnerNo,
      };
    },
    buttonText() {
      if (this.isMarketSettled) {
        if (this.contract.settledStatus === 1) {
          return 'Yes';
          // this.contract.payoutType === 0
        } else if (this.contract.settledStatus === 2) {
          return 'No';
        }
        return 'N/A';
      }
      if (this.hasMaintenance) {
        return 'Trading Paused';
      }

      if (isMarketExpired(this.market)) {
        return this.isLayoutMobile ? 'Pending' : 'Pending Settlement';
      }

      return this.market.status;
    },
    isWinnerYes() {
      // this.contract.payoutType === 1
      return this.contract.settledStatus === 1;
    },
    isWinnerNo() {
      // this.contract.payoutType === 0
      return this.isMarketSingle && this.contract.settledStatus === 2;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-disabled-outcome-v2/market-disabled-outcome-v2.js